const Range = require('../classes/range')
const validRange = (range, options) => {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, options).range || '*'
  } catch (er) {
    return null
  }
}
module.exports = validRange



//////////////////
// WEBPACK FOOTER
// ./~/semver/ranges/valid.js
// module id = 2205
// module chunks = 0